import React, { useEffect, useState } from 'react';
import GetStartedCard from './get-started-card';
import { STORAGE_KEYS } from 'utils/constants';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AccountComplete from './account-complete';
import BusinessCards from './business-cards';
import useDashboardContext from 'contexts/dashboard.context';
import AssignAdminModal from 'components/modals/auth-modal/assign-admin-modal';
import PageHeader from 'components/base/page-header';
import { isOnboardingCompleted } from 'utils/functions';

const GetStarted = () => {
  const [searchParams] = useSearchParams();
  const [assignAdminModal, setAssignAdminModal] = useState(false);
  const navigate = useNavigate();
  const { onboarding, setIsBackLink } = useDashboardContext();

  const lastName = localStorage.getItem(STORAGE_KEYS.LAST_NAME);
  const onboardingCompleted = onboarding.length && isOnboardingCompleted(onboarding);

  const setAssignModal = () => {
    navigate('/get-started');
  };

  useEffect(() => {
    setIsBackLink(false);
  }, []);

  useEffect(() => {
    if (searchParams.get('assign_admin')) setAssignAdminModal(true);
    return () => setAssignAdminModal(false);
  }, [searchParams]);

  return (
    <div>
      <PageHeader
        title={`Welcome ${lastName} 👋🏼`}
        subtitle='We’re here to help you get things rolling'
      />
      <div className='flex gap-6 flex-wrap lg:flex-nowrap'>
        {onboardingCompleted ? <AccountComplete /> : <GetStartedCard />}
      </div>
      <BusinessCards />
      <AssignAdminModal isOpen={assignAdminModal} onClose={setAssignModal} />
    </div>
  );
};

export default GetStarted;
